import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
`;

const Title = styled.h1`
    color: #333;
    text-align: center;
`;

const Progress = styled.div`
    margin-bottom: 20px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
`;

const QuestionContainer = styled.div`
    background: #f4f4f4;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
`;

const QuestionText = styled.p`
    font-size: 18px;
    margin-bottom: 20px;
`;

const Options = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
`;

const Button = styled.button`
    background: #333;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 10px;

    &:hover {
        background: #555;
    }
`;

const ResultContainer = styled.div`
    background: #e9e9e9;
    padding: 20px;
    border-radius: 5px;
    text-align: center;
`;

const ResultText = styled.h2`
    font-size: 24px;
    margin-bottom: 20px;
`;

const DescriptionText = styled.p`
    font-size: 18px;
    line-height: 1.6;
`;

const AnswerTable = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    font-size: 18px;
    justify-content: center;
`;

const AnswerItem = styled.div`
    margin: 5px;
    padding: 5px 10px;
    border: 1px solid #333;
    border-radius: 3px;
`;

const App = () => {
    const initialQuestions = [
        { question: "사람들과 함께 있을 때 에너지가 생긴다.", type: "E" },
        { question: "새로운 사람들을 만나는 것을 즐긴다.", type: "E" },
        { question: "조용한 환경에서 혼자 일하는 것을 선호한다.", type: "I" },
        { question: "대화를 시작하기보다는 다른 사람이 먼저 말을 걸어주기를 기다린다.", type: "I" },
        { question: "큰 모임보다는 소수의 친한 친구들과 시간을 보내는 것을 좋아한다.", type: "I" },
        { question: "구체적인 사실과 세부사항에 집중한다.", type: "S" },
        { question: "현재에 집중하며 과거의 경험을 중요하게 여긴다.", type: "S" },
        { question: "추상적인 아이디어나 개념에 관심이 많다.", type: "N" },
        { question: "미래의 가능성을 상상하는 것을 즐긴다.", type: "N" },
        { question: "일상적인 일보다는 새로운 도전을 선호한다.", type: "N" },
        { question: "결정을 내릴 때 논리와 사실에 기반한다.", type: "T" },
        { question: "감정보다는 이성을 중요하게 여긴다.", type: "T" },
        { question: "다른 사람의 감정을 고려하여 결정을 내린다.", type: "F" },
        { question: "조화로운 관계를 유지하는 것을 중요하게 여긴다.", type: "F" },
        { question: "직관과 감정에 따라 행동하는 경향이 있다.", type: "F" },
        { question: "계획을 세우고 그대로 실행하는 것을 좋아한다.", type: "J" },
        { question: "체계적이고 조직적인 환경에서 일하는 것을 선호한다.", type: "J" },
        { question: "유연하게 상황에 적응하는 것을 즐긴다.", type: "P" },
        { question: "마감 기한에 임박해서 일을 처리하는 편이다.", type: "P" },
        { question: "즉흥적인 결정을 내리는 것을 좋아한다.", type: "P" }
    ];

    const descriptions = {
        'ISTJ': '신중하고 조용하며 집중력과 실제적인 논리로 성공을 거두는 성격',
        'ISFJ': '조용하고 친근하며 책임감 있고 양심적인 성격',
        'INFJ': '인내심 있는 통찰력과 창의력으로 새로운 아이디어에 눈을 뜨는 성격',
        'INTJ': '독창적인 마음과 지적 호기심으로 새로운 아이디어를 이끌어내는 성격',
        'ISTP': '조용하고 과묵하며 논리적이고 분석적으로 문제를 해결하는 성격',
        'ISFP': '차분하고 친절하며 현재의 순간을 즐기는 성격',
        'INFP': '이상주의적이고 충실하며 가치 중심적인 성격',
        'INTP': '끊임없이 새로운 지식에 목말라하는 혁신적인 발명가 성격',
        'ESTP': '즉흥적이고 활동적이며 현실적인 문제 해결에 능숙한 성격',
        'ESFP': '사교적이고 활동적이며 수용력 있는 현실주의자 성격',
        'ENFP': '열정적이고 창의적이며 항상 새로운 가능성을 찾는 성격',
        'ENTP': '풍부한 상상력을 가지고 새로운 것에 도전하는 성격',
        'ESTJ': '사실적이고 실용적이며 조직화와 체계화에 뛰어난 성격',
        'ESFJ': '동정심이 많고 협조적이며 친선을 도모하는 성격',
        'ENFJ': '카리스마 있고 이상주의적이며 사람들을 이끄는 리더 성격',
        'ENTJ': '대담하고 강력한 의지를 가진 지도자 성격'
    };
    const shuffleQuestions = (questions) => {
      return questions.sort(() => Math.random() - 0.5);
    };
    const [questions] = useState(() => shuffleQuestions([...initialQuestions]));
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [result, setResult] = useState(null);
    const [startTime, setStartTime] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => {
            if (Date.now() - startTime > 300000) {
                resetTest();
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [startTime]);

    const handleAnswer = (answer) => {
        const newAnswers = [...answers];
        newAnswers[currentQuestion] = answer;
        setAnswers(newAnswers);

        if (currentQuestion + 1 < questions.length) {
            setCurrentQuestion(currentQuestion + 1);
        } else {
            calculateResult(newAnswers);
        }
    };

    const calculateResult = (finalAnswers) => {
        const scores = { 'E': 0, 'I': 0, 'S': 0, 'N': 0, 'T': 0, 'F': 0, 'J': 0, 'P': 0 };

        finalAnswers.forEach((answer, index) => {
            const type = questions[index].type;
            scores[type] += answer === 'yes' ? 1 : 0;
            scores[getOppositeType(type)] += answer === 'no' ? 1 : 0;
        });

        const mbtiResult = (scores['E'] > scores['I'] ? 'E' : 'I') +
                          (scores['S'] > scores['N'] ? 'S' : 'N') +
                          (scores['T'] > scores['F'] ? 'T' : 'F') +
                          (scores['J'] > scores['P'] ? 'J' : 'P');
        setResult(mbtiResult);
    };

    const getOppositeType = (type) => {
        const opposites = { 'E': 'I', 'I': 'E', 'S': 'N', 'N': 'S', 'T': 'F', 'F': 'T', 'J': 'P', 'P': 'J' };
        return opposites[type];
    };

    const resetTest = () => {
        setCurrentQuestion(0);
        setAnswers([]);
        setResult(null);
        setStartTime(Date.now());
    };

    const goBack = () => {
        if (currentQuestion > 0) {
            const newAnswers = [...answers];
            newAnswers[currentQuestion - 1] = undefined;
            setAnswers(newAnswers);
            setCurrentQuestion(currentQuestion - 1);
        }
    };

    return (
        <Container>
            <Title>MBTI 테스트</Title>
            {!result ? (
                <>
                    <AnswerTable>
                        {questions.map((_, index) => (
                            <AnswerItem key={index}>
                                {index + 1} {answers[index] ? (answers[index] === 'yes' ? 'O' : 'X') : ''}
                            </AnswerItem>
                        ))}
                    </AnswerTable>
                    <Progress>
                        질문 {currentQuestion + 1} / {questions.length}
                    </Progress>
                    <QuestionContainer>
                        <QuestionText>{questions[currentQuestion].question}</QuestionText>
                        <Options>
                            <Button onClick={() => handleAnswer('yes')}>예</Button>
                            <Button onClick={() => handleAnswer('no')}>아니오</Button>
                        </Options>
                        {currentQuestion > 0 && (
                            <Options>
                                <Button onClick={goBack}>
                                    뒤로 가기
                                </Button>
                            </Options>
                        )}
                    </QuestionContainer>
                </>
            ) : (
                <ResultContainer>
                    <ResultText>당신의 MBTI 유형은 {result}입니다.</ResultText>
                    <DescriptionText>{descriptions[result]}</DescriptionText>
                    <Button onClick={resetTest}>테스트 다시 하기</Button>
                </ResultContainer>
            )}
        </Container>
    );
};

export default App;
